const isProduction = !!window?.__env__;
const env = isProduction ? window.__env__ : process.env;

export default {
  ...env,
  REACT_APP_FIREBASE_CLIENT: JSON.parse(env.REACT_APP_FIREBASE_CLIENT)
};
